export default __webpack_public_path__ + "static/media/Bolts of Winter's Breath.13753c22.jpg";